export default function Cover() {
    return (
        <div className="cover-img"></div>
    )
}
